const EGDSActionListItemSpacingMap = [['standard', 'standard'], ['relaxed', 'relaxed'], ['none', 'none']];
const EGDSActionListItemSpacings = new Map(EGDSActionListItemSpacingMap);
export { EGDSActionListItemSpacings };